import React from 'react';

function Header({ 
    globalCount, 
    soundEnabled, 
    toggleSound,
    setShowSettings,
    isOnline,
    handleGoBack
}) {
    return (
        <header className="app-header">
            <div className="global-counter">
                🌍 Global Clicks: <span>{globalCount.toLocaleString()}</span>
            </div>
            <div className="title-area">
                <h1 className="click-mania-title">Click Mania</h1>
                <p className="app-subtitle">by FatReeg</p>
            </div>
            <div className="header-buttons">
                <button className="back-button" onClick={handleGoBack}>
                    Change User
                </button>
                <div className="control-buttons">
                    <button
                        className={`sound-toggle ${soundEnabled ? 'sound-on' : 'sound-off'}`}
                        onClick={toggleSound}
                        title={soundEnabled ? 'Sound On' : 'Sound Off'}
                    >
                        {soundEnabled ? '🔊' : '🔇'}
                    </button>
                    <button
                        className="settings-button"
                        onClick={() => setShowSettings(true)}
                        title="Settings"
                    >
                        ⚙️
                    </button>
                </div>
            </div>
        </header>
    );
}

export default Header;